module.exports = __webpack_public_path__ + "img/centerpiece.d10cdb97.png";